import {ValidationMessage} from "@fedelta-pos/data-client";

export class ReorderStatus {
    constructor(public ordered: boolean,
                public quickPay: boolean,
                public reorderGroupOrderName?: string, public groupOrderValidationMessages?: ValidationMessage[], public groupOrderError?: unknown) {
    }
}
